@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/mixins/typography" as t;


.panel {
  position: absolute;
  top: 0;
  left: 0;
  z-index: v.$z-index-panel-wrapper;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: v.$panel-wrapper-width;
  transition: all 0.2s linear;

  @include m.containerMedia(v.$js-defined-mobile-breakpoint) {
    width: 100%;
    overflow: hidden;
    background-color: v.$palette-gray-100;
  }

  &.isLoading {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.panel .loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
